// European Roulette Configuration

export const RED_NUMBERS = [1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23, 25, 27, 30, 32, 34, 36];
export const BLACK_NUMBERS = [2, 4, 6, 8, 10, 11, 13, 15, 17, 20, 22, 24, 26, 28, 29, 31, 33, 35];
export const GREEN_NUMBERS = [0];

// Wheel numbers sequence in European Roulette
export const WHEEL_ORDER = [
  0, 32, 15, 19, 4, 21, 2, 25, 17, 34, 6, 27, 13, 36, 11, 30, 8, 23, 10, 5, 24, 16, 33, 1, 20, 14, 31, 9, 22, 18, 29, 7, 28, 12, 35, 3, 26
];

export const getNumberColor = (number) => {
  const num = Number(number);
  if (RED_NUMBERS.includes(num)) return 'red';
  if (BLACK_NUMBERS.includes(num)) return 'black';
  return 'green';
};

export const calculatePayout = (bet, winningNumber) => {
  if (!bet) return 0;
  const { type, value, amount } = bet;
  const num = Number(winningNumber);

  switch (type) {
    case 'number':
      return num === Number(value) ? amount * 36 : 0;
    case 'color':
      return getNumberColor(num) === value ? amount * 2 : 0;
    case 'parity':
      if (num === 0) return 0;
      const isEven = num % 2 === 0;
      return (value === 'even' && isEven) || (value === 'odd' && !isEven) ? amount * 2 : 0;
    case 'half':
      if (num === 0) return 0;
      return (value === '1-18' && num >= 1 && num <= 18) || (value === '19-36' && num >= 19 && num <= 36) ? amount * 2 : 0;
    case 'dozen':
      if (num === 0) return 0;
      if (value === '1st 12' && num >= 1 && num <= 12) return amount * 3;
      if (value === '2nd 12' && num >= 13 && num <= 24) return amount * 3;
      if (value === '3rd 12' && num >= 25 && num <= 36) return amount * 3;
      return 0;
    default:
      return 0;
  }
};
